import { DoorConfiguration as contex } from '../DoorConfiguration';
import * as helper from './Shared';

import store from '@/store/index';
import { Characteristic, ValueDefinition } from '../types';

// KTU_MM_TUERBLATT_DICKE_NEU
export const calculateTuerblattDickeNeu = () => {
    let result: number = 0;

    let massB: number = 0;
    let massGB: number = 0;

    const doorThickness = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATT_DICKE', contex.ModelSelection );

    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions);
    const zierleistenVariantenB = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.Functions);
    const zierleistenVariantenGB = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.Functions);

    switch (zierleistenArt) {
        case '0':
        case '1':
        case '2':
            result = doorThickness;
            break;
        case '3':
        case '5':
        case '6':
            massB = zierleistenVariantenB !== 'ZV0' ? 10 : 0;
            massGB = zierleistenVariantenGB !== 'ZV0' ? 10 : 0;
            result = doorThickness + massB + massGB;
            break;
        case '4':
        case '7':
            massB = zierleistenVariantenB !== 'ZV0' ? 15 : 0;
            massGB = zierleistenVariantenGB !== 'ZV0' ? 15 : 0;
            result = doorThickness + massB + massGB;
            break;
        default:
            result = doorThickness;
            break;
    }

    return result;
};

//CUST_MM_BANDART
export const calculateBandArt = (): ValueDefinition => {
    const articleNumber = helper.GetDependencyValueCode('KTU_MM_ARTIKELNR', contex.ModelSelection );
    const modelle = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection );
    const aufgherichtung = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions );
    const zierleistenArt = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENART', contex.Functions );
    const zierleistenVariantenBS = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.Functions );
    const zierleistenVariantenGBS = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.Functions );
    const glassVariante = helper.GetDependencyValueCode('KTU_MM_GLASVARIANTE', contex.Functions);
    const schalschuts = helper.GetDependencyValueCode('KTU_MM_FUNKTION_S', contex.ModelSelection);
    
    
    var isStandart = true;
     if(((parseInt(zierleistenArt) > 0 && parseInt(zierleistenArt) <= 4) && (zierleistenVariantenBS != "ZV0" || zierleistenVariantenGBS != "ZV0"))  || glassVariante != '0'  || parseInt(schalschuts) >= 39){
         isStandart = false;
     }
     const searchArtickleNumber = articleNumber + "-" + aufgherichtung;
     var data = 
     [
         {
             "key" : "TW-BERT200-D1-A-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT200-D1-A-O-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT200-D2-A-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT200-D2-A-O-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT230-D1-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT230-D1-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT230-D2-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT230-D2-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT300-D1-A-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT300-D1-A-O-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT300-D2-A-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT300-D2-A-O-LI",
             "values" : ["SFS ANUBA","GOLL-L"]
         },
         {
             "key" : "TW-BERT330-D1-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT330-D1-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT330-D2-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
     
         {
             "key" : "TW-BERT330-D2-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT400-D1-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT400-D1-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT400-D2-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT400-D2-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT430-D1-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT430-D1-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT430-D2-A-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT430-D2-A-O-LI",
             "values" : ["GOLL-L","GOLL-L"]
         },
         {
             "key" : "TW-BERT200-D1-A-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT200-D1-A-O-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT200-D2-A-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT200-D2-A-O-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT230-D1-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT230-D1-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT230-D2-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT230-D2-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT300-D1-A-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT300-D1-A-O-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT300-D2-A-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT300-D2-A-O-RI",
             "values" : ["SFS ANUBA","GOLL-R"]
         },
         {
             "key" : "TW-BERT330-D1-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT330-D1-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT330-D2-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT330-D2-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT400-D1-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT400-D1-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT400-D2-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT400-D2-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT430-D1-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT430-D1-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT430-D2-A-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
         {
             "key" : "TW-BERT430-D2-A-O-RI",
             "values" : ["GOLL-R","GOLL-R"]
         },
     ]

     var result = "";

    if(modelle == "CERT")
    {
        result = "SFS ANUBA"

    }else if(modelle == "VERT" && aufgherichtung.includes("L"))
    {
        result = "GOLL-L";

    }else if(modelle == "VERT" && aufgherichtung.includes("R"))
    {
        result = "GOLL-R";

    }else if(modelle == "BERT" && aufgherichtung == "LA")
    {
        result = "GOLL-L";

    }else if (modelle == "BERT" && aufgherichtung == "RA")
    {
        result = "GOLL-L";
    }else {
       
        for(var i = 0; i < data.length; i++)
        {
            if(data[i].key === searchArtickleNumber){
                if(isStandart){
                    result = data[i].values[0];
                }else {
                    result = data[i].values[1];
                }
            }
        }
    }
    
    const customBandArtCharacteristic  = store.state.functionsModule.functionsModel.characteristics.filter((c: Characteristic) => c.code === 'CUST_MM_BANDART')[0];
    const bandArtResult: ValueDefinition = typeof customBandArtCharacteristic !== 'undefined' ? customBandArtCharacteristic.values.filter((v: ValueDefinition) => v.value === result)[0] : null;
    return bandArtResult;
}

//KTU_MM_SCHALLSCHUTZ_PLUS
export const calculateSchallschutzSonderCharacteristic = (): ValueDefinition => {

    let lltNumber: string = '0';
    const schallschutzSonderValue = helper.GetDependencyValueCode('CUST_MM_SCHALLSCHUTZ_PLUS', contex.Functions);
    if (schallschutzSonderValue === '1' ) {
        const functionSValue = helper.GetDependencyValueCode('KTU_MM_FUNKTION_S', contex.ModelSelection);
        lltNumber = functionSValue;
    }
    else if (schallschutzSonderValue === '2' ) {
        lltNumber = 'VORSATZSCHALE';
    }
    else if (schallschutzSonderValue === '3' ) {
        lltNumber = 'POLSTERUNG';
    }

    const schallschutzSonderCharacteristic  = store.state.functionsModule.functionsModel.characteristics.filter((c: Characteristic) => c.code === 'KTU_MM_SCHALLSCHUTZ_PLUS')[0];
    const schallschutzSonderCharacteristicValue: ValueDefinition = typeof schallschutzSonderCharacteristic !== 'undefined'
        ? schallschutzSonderCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0]
        : null;

    return schallschutzSonderCharacteristicValue;
};